import styled from "styled-components";
import colors from "../../../../../../config/colors";

export const ChangeBarContainer = styled.div``;


export const BarBox = styled.div`
display: flex;`;

export const Divider = styled.div`
  min-width:1px;
  background-color:${colors.secondary};
  transform:scaleY(1.5);
`;
export const Block = styled.div`
  background-color: ${props=>props.color};
  min-width: ${(props) => props.width}%;
  width: ${(props) => props.width}%;
  padding: 0px 0px;
  box-sizing:border-box;
  color:${props=>props.color === colors.darkBackground? colors.darkPrimary : colors.background};
`;
